export const userInfo: {
  name: string
  nick: string
  avatar: string
  introduction: string
  address: string
  bgImg: string
  link: string
}[] = [
  {
    name: 'SWOG',
    nick: 'SWOG',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/1920994f15d242279a492e89cdbbfcf1.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/7822dc237963415ebb2982d9ae4e7329.jpg',
    introduction: "Daniel González, knows as SWOG, is a Spanish Artist from Salamanca. \n \nHe has one of Europe's biggest electronic music channels with more than 500.000 subscribers and 125.000.000 plays up to date. \n \n SWOG stands out for his dynamic and energetic sets in which they mix huge hits or hip-hop/trap with the best selection of Bass Music.\n \nThese famous mashups have been supported by the most recognized DJs and have been played in some of the greatest festivals around the world like Ultra Music Festival.\n \nMoreover, this emerging artist is starting to release their original music, which will be a breaking point in his music career. In the next years, SWOG will push hard to be located among the major references in the bass music scene.",
    address: '0x24FE2A019A0d0DCbEcD3b3334194192e0f94B9e7',
    link: 'https://youtube.com/c/swog'
  }, 
  {
    name: 'CoralCorp',
    nick: 'CoralCorp',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/31505ed732274068b006502728f6d6b9.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/8f4ca704cca24ab2aa673852e496cd77.jpg',
    introduction: "I am a crypto artist. I try to reflect a future in which the mind merges with the digital. The sense of individuality is enhanced in worlds without physical limits and it is in that reality where I try to reflect the future with my art. I like to hide history, geometry and criticism in it.",
    address: '0x25d199B6f9EFe9b29d2e71FA72CFFaB24F9d6B51',
    link: 'https://ello.co/coralcorp'
  }, 
  {
    name: 'Cookie Munster',
    nick: 'Cookie Munster',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/a54f119ce2754fff85aeb8804f50af26.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/6bbf884e31ef41f1919c8daa795155f3.jpg',
    introduction: 'A dreamer who always tries to do things that he never thought he could. Each and every one of the paintings that he puts out is a piece of work that will always remind him that impossible is nothing unless we try. These are the works of a self-taught artist after many years of experimenting, observing and learning from other great artists. \n \nIt is my hope that in that short moment that people pause to view my art, it would warm their hearts, lift their spirits or at the very least put a smile on their faces.',
    address: '0xb767aC95B575ff5285e34D462fF9bB1efDaa227D',
    link: 'http://www.afzane.com/'
  },
  {
    name: 'srnArtGallery',
    nick: 'srnArtGallery',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/592339960f7e47a2a183fb4494fdd4fb.png',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/1cc71816153142bf99d432abe1014628.jpg',
    introduction: "srnArtGallery is a union of artists. They are making art such as oilpainting, guache, watercolor, sketch, illustrations, generative art, processing art, gifs etc. Their purpose is to reach art to everyone.",
    address: '0x65803AE4bD538C11feC1A74E7a2E5855e3A96AFF',
    link: 'https://www.instagram.com/srn.art/'
  },
  {
    name: 'Chiara Magni',
    nick: 'Chiara Magni',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/23fb79ca3fb84a8da9ffdb377dba6b3d.jpeg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/a2907a01ea01451e86a95a2764aa2c38.jpg',
    introduction: "I'm an italian painter, I do oil on canvas with the finger paint method, after a lot of works I started to sell my art around the word. Now I want to bring my art on the blockchains because crypto is the future of money and art.",
    address: '0x49a66E6E38782D14eDe30E2FCa6a4783263Ce538',
    link: 'https://chiaramagni.com/'
  },
  {
    name: 'Hamid',
    nick: 'Hamid',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/8e7c246cfb564b579871ebe9cf297f49.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/c160da8b68424361adc8cedbb1ab84bf.jpg',
    introduction: "Hamid is an experienced artist in both 2D/3D art. He started in 2010 by learning anatomy/animation art, and making exclusive designs for cinema. As an artist/animator, he tries to leave his mark in all his NFT. His art is unique and original, from scratch to final product.",
    address: '0x867C67F1C94146b63d6dE764DA77FFa8209e82C0',
    link: 'https://www.instagram.com/hamid_cgartist/'
  },
  {
    name: 'Muwasha iProjects',
    nick: 'Muwasha iProjects',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/7675b3cae7754818a7dd7d0c05cc602f.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/f9a89798386c423c958757937bb07b30.jpg',
    introduction: "Art & Creativa Direction - Multimedia designer, 3D Motion Graphics, Photo, VideoMapping, Live Visuals",
    address: '0x28172f989e162F0d9D7fCf0f4097ca125C173b05',
    link: 'https://www.instagram.com/muwasha/'
  }, 
  {
    name: 'Irene Cerezo',
    nick: 'Irene Cerezo',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/57542886851749979d1f2e0e1b55824c.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/c9ae07df846a42d1864332cc02a6cb22.jpg',
    introduction: "Hello! I am a graphic designer starting in the world of motion graphics. I consider each new project a great opportunity to learn and grow. I always put my heart to every art piece, trying my best to achieve a shocking and quality job. I describe myself as a restless creative with disruptive ideas.",
    address: '0xd7c35495245F6C2d1e52B1580151A947507F9ae0',
    link: 'https://vimeo.com/irenecerezo?id_curso=1502'
  },
  {
    name: 'TSA Collections',
    nick: 'TSA Collections',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aaa30b885e2444c9150241cb7b0eb91.png',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/e02d4288f44f4684854cd14359c88656.png',
    introduction: "TSA Collections is bringing together the world of arts and fashion powered by blockchain technology into NFT digital space. Each collection, represented by an NFT, contains a unique art story. By collecting an NFT, users are able to redeem the completed NFT for physical artworks. TSA Top 3 Collections: CaoJun NFT limited editions, Peter Blake editions. Gus Bawab and Emmanuel Robbe editions..",
    address: '0x539db6158e07cd89Fc0295F28644c9A9578c92de',
    link: 'https://www.teaswap.live/nft-marketplace'
  },
  // {
  //   name: 'Morgana Tavella',
  //   avatar: '/images/user/icon_avater_MorganaTavella.jpg',
  //   bgImg: '/images/user/user_bg_MorganaTavella.jpg',
  //   introduction: "Henlo ♥I'm a self-thaught digital artist from Italy, currently based in Barcelona. I work as a freelancer, realizing art commissions of original characters, fan arts, portraits. I love challenging myself with new projects, and that's the reason why I minted some of my artworks as NFTs on BakerySwap, actually selling some of them! Crypto art is an interesting unexplored universe and I want to be there while it keeps growing.",
  //   address: '0xDc72E0AD3D404d2a2C2ed77E76660E22b90B88fe',
  //   link: 'https://www.artstation.com/morgiron'
  // },
  {
    name: 'Mr Anderson',
    nick: 'Mr Anderson',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x737945deADB45304858467E99b6196D5699DA8dd',
    link: ''
  },
  {
    name: 'Manzo',
    nick: 'Manzo',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x83B1B539A374079Fd8B1AAaa25498f29812a3324',
    link: ''
  },
  {
    name: 'ELINE',
    nick: 'ELINE',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x97865f88E195bBEdc3B38F8BD879eEFCed7B0470',
    link: ''
  },
  {
    name: 'Aightek',
    nick: 'Aightek',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x142e6EE40bd42643aA4D3F7A0ae066997F902788',
    link: ''
  },
  {
    name: 'ernkurtel',
    nick: 'ernkurtel',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0xB58A031048Cb54568cECB22dEf51511C76a67350',
    link: ''
  },
  {
    name: 'Nude Robot',
    nick: 'Nude Robot',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x992fbe2d1da41bd282d579d4b16f73232c78e20d',
    link: ''
  },
  {
    name: 'Theblacksea_NFT',
    nick: 'Theblacksea_NFT',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x5FB5E55431AD15F6F262a594D3bE218aCedB9268',
    link: ''
  },
  {
    name: 'ToyBoy',
    nick: 'ToyBoy',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0x5E809dd19e39792E24477c73246d46452AC6116a',
    link: ''
  },
  {
    name: 'Gerz',
    nick: 'Gerz',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0xEf8AE853F880B8a9Abf654ad5681A34B1D4C0473',
    link: ''
  },
  {
    name: 'Heuckendorff',
    nick: 'Heuckendorff',
    avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
    bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
    introduction: "The artist doesn't have self intro",
    address: '0xeC92838c3613c1f5c4e7812a8Db6cFE904f6F45d',
    link: ''
  }
]

export const userInfoDefault: {
  name: string
  avatar: string
  introduction: string
  address: string
  bgImg: string
  link: string
} = {
  name: '',
  avatar: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg',
  bgImg: 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/0aefa6d04b3a457f8a9e637c51715015.jpg',
  introduction: "The artist doesn't have self intro",
  address: '',
  link: ''
}

export const userInfoEmpty: {
  name: string
  avatar: string
  introduction: string
  address: string
  bgImg: string
  link: string
} = {
  name: '',
  avatar: '',
  bgImg: '',
  introduction: "",
  address: '',
  link: ''
}

export interface userInfoProps{
  avatar: string
  banner: string
  introduction: string
  link: string
  nick: string,
  address: string
}

export const userInfoEmptyV2: userInfoProps = {
  avatar: '',
  banner: '',
  introduction: "",
  link: '',
  nick: '',
  address: ''
}